module.exports = __webpack_public_path__ + "assets/img/58a5ffe834e76dc450c9e2cb8c8d72c0.png";